<template>
<div style="height: calc(100% - 60px);">
    <div style="height: 60px; line-height: 60px;">Admin</div>
    <el-menu style="height: 100%;"
      default-active="1"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose">
      <router-link to="/admin/projects">
      <el-menu-item index="1" class="admin-side-bar-item">
        <i class="el-icon-location-outline1"></i>
        <span>Projects</span>
      </el-menu-item>
      </router-link>
      <router-link to="/admin/contractors">
      <el-menu-item index="2" class="admin-side-bar-item">
        <i class="el-icon-s-check"></i>
        <span>Contractors</span>
      </el-menu-item>
      </router-link>
      <router-link to="/admin/users">
      <el-menu-item index="3" class="admin-side-bar-item">
        <i class="el-icon-user"></i>
        <span>Users</span>
      </el-menu-item>
      </router-link>
    </el-menu>
</div>
</template>
<script>
  export default {
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>
<style scoped>
.admin-side-bar-item {
  text-align: left;
}
</style>